<template>
  <div style="width: 200px" class="assortment-groups d-flex flex-column align-start">
    <h4 class="text-truncate w-100" :title="firstGroup.name">
      {{ firstGroup.name }}
    </h4>
    <h4 v-if="secondGroup" class="text-truncate w-100" :title="secondGroup.name">
      {{ secondGroup.name }}
    </h4>
    <v-tooltip
      v-if="moreGroups.length"
      content-class="bg-white elevation-3"
      location="bottom"
      variant="text"
    >
      <template #activator="{ props: activatorProps }">
        <span v-bind="activatorProps" class="tooltip">{{ tooltip }}</span>
      </template>
      <span v-for="(group, index) in groups" :key="index">{{ group.name }}<br /></span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    groups: {
      type: Array,
      required: true,
    },
  },

  data() {
    return { moreThreshold: 2 };
  },

  computed: {
    firstGroup() {
      return this.groups.length ? this.groups[0] : {};
    },
    secondGroup() {
      return this.groups.length > 1 ? this.groups[1] : false;
    },
    tooltip() {
      return this.groups.length > this.moreThreshold
        ? `+ ${this.groups.length - this.moreThreshold} ${this.$t(
            'workpackagePage.scope.moreLabel'
          )}`
        : '';
    },
    moreGroups() {
      return this.groups.length ? this.groups.slice(this.moreThreshold) : [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.assortment-groups {
  min-width: 180px;
  width: 180px;
}

.title {
  padding-bottom: 0px;
  font-weight: bold;
  width: 100%;
}

.tooltip {
  color: $assortment-primary-colour;
  font-weight: bold;
  cursor: pointer;
}
</style>
